import { getClosestCoordinateByStep } from "../../components/datasheet/datasheet.utils";

export const getDroppedFieldYCoordinate = ({
  firstDroppedFieldY,
  previousElement,
  verticalGrid,
  snapToGrid,
}: {
  firstDroppedFieldY: number;
  previousElement?: { coordinates: { y: number }; height: number };
  verticalGrid: number;
  snapToGrid: boolean;
}) => {
  if (!previousElement) {
    return firstDroppedFieldY;
  }

  const stackedY = previousElement.coordinates.y + previousElement.height + verticalGrid;

  if (!snapToGrid) {
    return stackedY;
  }

  return getClosestCoordinateByStep(stackedY, verticalGrid);
};
